module.exports = __webpack_public_path__ + "img/ok-form.5d81b04b.svg";